import React from 'react';
import {
  Collapse as RawCollapse,
  CollapseProps as RawCollapseProps,
} from 'react-collapse';

export type CollapseProps = Omit<RawCollapseProps, 'theme'> & {
  className?: string;
  contentClassName?: string;
};

/**
 * This re-use the `react-collapse` in a manner that is more suitable to be used
 * with emotion.
 */
const Collapse = ({ className, contentClassName, ...rest }: CollapseProps) => (
  <RawCollapse
    theme={{
      collapse: className,
      content: contentClassName,
    }}
    {...rest}
  />
);

export default Collapse;
